import React, { useMemo } from 'react';

import { useLoading } from './useLoading';

import logo from './assets/logo-dragon-s-force.png';
import background from './assets/background.png';
import pascalLogo from './assets/pascalLogo.png';

import './loading.scss';

export const Loading = () => {
  const { progress } = useLoading();
  const transformProgress = useMemo(() => {
    return progress - 100;
  }, [progress]);

  return (
    <section className='loading__container' style={{
      backgroundImage: `url(${background})`,
    }}>
      <div className='loading_image_content' >
        <div className='loading_image_content_logo_content'>
          <img src={logo} alt="logo"  className='loading_image_content_logo'/>
          <div className='loading_image_content_progress'>
            <section className='loading__bar__content'>
              <div className='loading__bar__progress' style={{
                transform: `translate(${transformProgress}%)`,
              }}/>
            </section>
          </div>
          <img src={pascalLogo} alt="logo"  className='loading_image_content_pg_logo'/>
        </div>
      </div>
    </section>
  );
};
